(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/category-menu/assets/javascripts/category-menu.js') >= 0) return;  svs.modules.push('/widgets/category-menu/assets/javascripts/category-menu.js'); "use strict";

var CATEGORU_MENU_WIDGET_SELECTOR = '.category-menu-widget';
var CATEGORY_MENU_SELECTOR = '.category-menu';
var FADE_LEFT_SELECTOR = '.category-menu-fade-left';
var FADE_RIGHT_SELECTOR = '.category-menu-fade-right';
var ACTIVE_ITEM_SELECTOR = '.category-menu-item-active';
var SHOW_FADE_CLASS = 'category-menu-fade-active';
var SCROLL_INTO_DURATION_MS = 600;

var _getBrowserCompatAnim = getBrowserCompatAnimationFrame(),
    reqAnimFrame = _getBrowserCompatAnim.reqAnimFrame,
    cancelAnimFrame = _getBrowserCompatAnim.cancelAnimFrame;

if (svs.core.detect.formfactor.mobile()) {
  init();
}

function getBrowserCompatAnimationFrame() {
  var browser = ['ms', 'moz', 'webkit', 'o'];
  var reqAnimFrame = requestAnimationFrame;
  var cancelAnimFrame = cancelAnimationFrame;
  browser.forEach(function (browser) {
    reqAnimFrame = reqAnimFrame || window["".concat(browser, "RequestAnimationFrame")];
    cancelAnimFrame = cancelAnimFrame || window["".concat(browser, "CancelAnimationFrame")] || window["".concat(browser, "CancelRequestAnimationFrame")];
  });
  return {
    reqAnimFrame: reqAnimFrame,
    cancelAnimFrame: cancelAnimFrame
  };
}

function init() {
  var categoryMenuWidgetEls = Array.prototype.slice.call(document.querySelectorAll(CATEGORU_MENU_WIDGET_SELECTOR));
  categoryMenuWidgetEls.forEach(function (categoryMenuWidgetEl) {
    var categoryMenuEl = categoryMenuWidgetEl.querySelector(CATEGORY_MENU_SELECTOR);

    if (!categoryMenuEl) {
      return;
    }

    var activeItem = categoryMenuEl.querySelector(ACTIVE_ITEM_SELECTOR);

    if (activeItem) {
      scrollUntilCentered(categoryMenuEl, activeItem);
    }

    var fadeLeftEl = categoryMenuWidgetEl.querySelector(FADE_LEFT_SELECTOR);
    var fadeRightEl = categoryMenuWidgetEl.querySelector(FADE_RIGHT_SELECTOR);
    var fadeLeftWidth = fadeLeftEl ? getComputedStyle(fadeLeftEl).width.replace(/\D/g, '') : 0;
    var fadeRightWidth = fadeRightEl ? getComputedStyle(fadeRightEl).width.replace(/\D/g, '') : 0;
    handleScroll();
    fadeLeftEl.classList.add(SHOW_FADE_CLASS);
    fadeRightEl.classList.add(SHOW_FADE_CLASS);
    categoryMenuEl.addEventListener('scroll', handleScroll);

    function handleScroll() {
      if (fadeLeftEl) {
        var ratio = categoryMenuEl.scrollLeft / fadeLeftWidth;

        if (ratio > 1) {
          ratio = 1;
        }

        fadeLeftEl.style.backgroundImage = "linear-gradient(90deg, rgba(0, 25, 50, ".concat(ratio, ") 0%, rgba(0, 25, 50, 0) 100%)");
      }

      if (fadeRightEl) {
        var scrollLeft = Math.ceil(categoryMenuEl.scrollLeft);
        var scrolledToRight = categoryMenuEl.scrollWidth - categoryMenuEl.offsetWidth;
        var offsetFromRight = scrolledToRight - scrollLeft;

        var _ratio = offsetFromRight / fadeRightWidth;

        if (_ratio > 1) {
          _ratio = 1;
        }

        fadeRightEl.style.backgroundImage = "linear-gradient(270deg, rgba(0, 25, 50, ".concat(_ratio, ") 0%, rgba(0, 25, 50, 0) 100%)");
      }
    }
  });
} 


function scrollUntilCentered(container, element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
      left = _element$getBoundingC.left,
      width = _element$getBoundingC.width;

  var start = null;
  var target = left + width / 2 - window.innerWidth / 2;
  var firstPos = container.scrollLeft;
  var pos = 0;

  function showAnimation(timestamp) {
    if (!start) {
      start = timestamp || new Date().getTime();
    }

    var elapsed = timestamp - start;
    var progress = elapsed / SCROLL_INTO_DURATION_MS;

    var outQuad = function outQuad(n) {
      return n * (2 - n);
    };

    var easeInPercentage = Number(outQuad(progress).toFixed(2));
    pos = firstPos + target * easeInPercentage;
    container.scrollTo(pos, 0);

    if (target !== 0 && pos >= firstPos + target || target === 0 && pos <= 0) {
      cancelAnimFrame(start);
      pos = 0;
    } else {
      reqAnimFrame(showAnimation);
    }
  }

  reqAnimFrame(showAnimation);
}
 })(window);